export default {
    information: {
        subtitle:
            '試しに請求書を作ってみましょう。はじめに、あなたの会社もしくは事業の連絡先情報を入力してください。',
        title: 'アカウントの作成が完了しました。',
    },
    pageForm: {
        addFax: 'FAX番号を追加',
        businessAdditionalText:
            'MakeLeapsからメールで請求書を発行した際、メールの返信先として使用することが可能です。',
        phoneAdditionalText:
            'MakeLeapsの利用登録および請求書発行時に書類に表示する連絡先として使用されます。',
        subtitle:
            '請求書作成の基本情報設定をはじめます。この設定は後からいつでも変更可能です。',
        title: '会社もしくは事業の連絡先情報',
    },
};
